import React from 'react';
import ThankYouContainer from 'features/ThankYou';

const ThankYouPage = () => <ThankYouContainer />;

export default ThankYouPage;
